import { render, staticRenderFns } from "./settlementInfo.vue?vue&type=template&id=31df9f78"
import script from "./settlementInfo.vue?vue&type=script&lang=js"
export * from "./settlementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports